import {FC, ReactNode} from 'react';

import {Text} from '@/src/ui';

import css from '../styles/InfoSection.module.css';

interface infoSectionProps {
  title: string;
  children: ReactNode;
}
const InfoSection: FC<infoSectionProps> = ({title, children}): JSX.Element => {
  return (
    <div>
      <div className={css.title}>
        <Text
          fontSize={Text.FONT_SIZE.SIZE_24}
          fontWeight={Text.FONT_WEIGHT.BOLD}
        >
          {title}
        </Text>
      </div>
      <div>{children}</div>
    </div>
  );
};

export default InfoSection;
